import React from 'react';
import { Section } from './Section';
import { Star, MapPin } from 'lucide-react';
const testimonials = [{
  quote: 'Compré un domingo a la noche. El lunes entré al estudio con el plan exacto de la clase. Las clases del Tomo 1 son exactamente lo que necesitaba para mis grupos de principiantes. Nunca más improviso.',
  name: 'Sofía M.',
  location: 'Buenos Aires',
  role: 'Profe de Stretching en Estudio Propio'
}, {
  quote: 'El Tomo 5, el de Stretching Suave, me cambió todo. El primer mes, alumnos que llevaban meses estancados mejoraron visiblemente su movilidad y su calidad de movimiento. El protocolo de seguridad me da la tranquilidad que antes no tenía.',
  name: 'Carolina R.',
  location: 'Rosario',
  role: 'Profe de Stretching en Centro de Adultos Mayores'
}, {
  quote: 'El sistema de Movilidad Funcional del Tomo 3 es único en el mercado. 10 clases listas para usar, con las transiciones descriptas paso a paso. Antes tardaba horas armando una secuencia. Ahora abro el PDF y en 5 minutos tengo todo listo.',
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Profe de Stretching Grupal e Individual'
}, {
  quote: 'La Guía de Variaciones en 3 Niveles eliminó el problema del grupo heterogéneo. Ahora muestro las 3 versiones de cada ejercicio y cada alumno elige la que le corresponde. Los avanzados se sienten desafiados y los principiantes se sienten seguros.',
  name: 'Luciana P.',
  location: 'Tucumán',
  role: 'Profe Particular y en Gimnasio'
}, {
  quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión mensual del calendario y la variedad de los 6 tomos. Los alumnos ahora quieren venir porque siempre hay algo nuevo.',
  name: 'Marcela G.',
  location: 'Mendoza',
  role: 'Profe de Stretching Online y Presencial'
}, {
  quote: 'El Script de Primera Clase del Bono 5 me salvó de perder alumnos que venían a probar. Ahora sé exactamente qué decir en cada momento. Mi tasa de conversión de primera clase a pack mensual subió de manera notable.',
  name: 'Laura V.',
  location: 'Santa Fe',
  role: 'Profe de Stretching en Estudio Propio'
}, {
  quote: 'El Cuerpo Seguro Pro me cambió la cabeza. Nunca había dimensionado el riesgo que corría sin adaptaciones claras para mis alumnos con condiciones especiales. Ahora trabajo con una tranquilidad que antes no tenía.',
  name: 'Ana R.',
  location: 'Salta',
  role: 'Profe de Stretching en Centro de Salud'
}];
export function ExtendedTestimonials() {
  return <Section className="bg-brand-dark" data-id="element-126" data-mp="1tsq4oq2yomrd">
      <div className="text-center mb-8 md:mb-12" data-id="element-127" data-mp="1ttriv3f9xpdb">
        <h2 className="text-2xl md:text-4xl font-display font-black text-white mb-2" data-id="element-128" data-mp="1g1lba5q6sqph">
          Lo que dicen los profes que ya lo usan:
        </h2>
        <p className="text-base md:text-xl text-brand-accent font-medium" data-id="element-129" data-mp="1k2wy63hoextz">
          +500 profes de Stretching de todo el país ya eligen STRETCHING 360™
        </p>
      </div>

      <div className="columns-1 md:columns-2 lg:columns-3 gap-4 space-y-4" data-id="element-130" data-mp="1b0nnndmer4gl">
        {testimonials.map((t, i) => <div key={i} className="bg-brand-light p-4 md:p-6 rounded-xl border border-white/5 break-inside-avoid shadow-lg" data-id="element-131" data-mp="rgp0o1obupp0" data-mpi={i}>
            <div className="flex text-yellow-400 mb-2" data-id="element-132" data-mp="mj6nfz3a1ob7">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 fill-current" data-id="element-133" data-mp="11fo1iy2uph1g" data-mpi={j} />)}
            </div>
            <p className="text-gray-300 text-sm italic mb-3 leading-relaxed" data-id="element-134" data-mp="wdowzkvdke2x">
              "{t.quote}"
            </p>
            <div data-id="element-135" data-mp="1acyagcs74u37">
              <div className="font-bold text-white text-sm" data-id="element-136" data-mp="15fy400rfppbk">{t.name}</div>
              <div className="flex items-center text-brand-accent text-xs mt-0.5 mb-0.5" data-id="element-137" data-mp="15fogqkxrxw9k">
                <MapPin className="w-3 h-3 mr-1" data-id="element-138" data-mp="1k42qzgxisn05" /> {t.location}
              </div>
              <div className="text-gray-400 text-xs" data-id="element-139" data-mp="1f72i6y9ad65c">{t.role}</div>
            </div>
          </div>)}
      </div>
    </Section>;
}